
/**
 * @param {QuoteRequestReviewAdd} model
 * @returns {ApiQuoteRequestReviewAdd}
 */
export const formatRequesterRateAdd = (model) => ({
  idCompanyQuotation: model.idCompanyQuotation,
  rating: model.rating,
  comment: model.comment,
  customerId: model.customer
})

/**
 * @param {QuoteRequestReviewUpdate} model
 * @returns {ApiQuoteRequestReviewUpdate}
 */
export const formatRequesterRateUpdate = (model) => ({
  IdCustomerEvaluation: model.rateId,
  rating: model.rating,
  comment: model.comment,
})
